import { ReportTranslation } from "../models/setting.model";
import api from "../lib/api";

export async function getReportTranslation(code?: string): Promise<{
  languages: string[];
  reportTranslation?: ReportTranslation;
}> {
  let url = `/setting/report/translation`;
  if (code) {
    url = `${url}/${code}`;
  }
  return await api<{
    languages: string[];
    reportTranslation?: ReportTranslation;
  }>({ url });
}
